import JackpotUpdateForm from "./jackpot-update-form";

export default JackpotUpdateForm;
